import { Link } from "react-router-dom";
import type { ReactNode } from "react";

interface PageHeroProps {
  title: string;
  subtitle?: string;
  image: string;
  breadcrumb?: string;
  children?: ReactNode;
}

export default function PageHero({ title, subtitle, image, breadcrumb, children }: PageHeroProps) {
  return (
    <section className="relative w-full h-[320px] md:h-[400px] overflow-hidden flex items-center">
      <img
        src={image}
        alt={title}
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/80 via-foreground-950/60 to-foreground-950/40"></div>
      <div className="relative z-10 w-full px-4 md:px-10 pt-16">
        <nav className="flex items-center gap-2 text-sm text-background-50/70 mb-4">
          <Link to="/" className="hover:text-background-50 transition-colors">
            首页
          </Link>
          {breadcrumb && (
            <>
              <i className="ri-arrow-right-s-line leading-none"></i>
              <span className="text-background-50">{breadcrumb}</span>
            </>
          )}
        </nav>
        <h1 className="font-heading text-3xl md:text-5xl font-extrabold text-background-50 tracking-tight">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-4 max-w-2xl text-sm md:text-base text-background-50/85 leading-relaxed">
            {subtitle}
          </p>
        )}
        {children}
      </div>
    </section>
  );
}